import React from "react";
import { MainHeader } from "../components/global/MainHeader";
import { AboutBody } from "../components/About/AboutBody";
import { Socials } from "../components/Home/Socials";

export const About = () => {
  return (
    <React.Fragment>
      {/* <MainHeader name={"About"} /> */}
      <AboutBody />
      <Socials imgSrc={"SBD/StrandsHairs.png"} />
    </React.Fragment>
  );
};
